var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_2488)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-90 4 32)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9911 8.00001C25.5218 7.99828 26.0313 8.2205 26.408 8.61774C26.7847 9.01499 26.9977 9.5548 27 10.1187L27 22.8813C27 24.0501 26.1001 25 24.9911 25L17.0089 25L13 20.7563L13 10.1187C13 8.9499 13.8999 8.00001 15.0089 8.00001L24.9911 8.00001ZM20.2 14.6587C20.1768 14.6257 20.1465 14.599 20.1119 14.5805C20.0771 14.5621 20.0389 14.5524 20 14.5524C19.9612 14.5524 19.923 14.5621 19.8882 14.5805C19.8536 14.599 19.8233 14.6257 19.8001 14.6587L17.3001 18.2C17.2722 18.2394 17.2552 18.2863 17.251 18.3355C17.2468 18.3845 17.2557 18.434 17.2765 18.4781C17.2972 18.5223 17.3291 18.5593 17.3686 18.5853C17.4081 18.6112 17.4537 18.6249 17.5 18.6249L18.75 18.6249C18.8163 18.6249 18.8799 18.653 18.9269 18.7027C18.9737 18.7525 19 18.8201 19 18.8906L19 20.4843C19 20.5547 19.0264 20.6223 19.0732 20.6722C19.1201 20.722 19.1838 20.7499 19.2501 20.7499L20.75 20.7499C20.8163 20.7499 20.88 20.722 20.9268 20.6722C20.9737 20.6223 21.0001 20.5547 21.0001 20.4843L21.0001 18.8906C21.0001 18.8201 21.0263 18.7525 21.0732 18.7027C21.1202 18.653 21.1838 18.6249 21.25 18.6249L22.5 18.6249C22.5464 18.6249 22.592 18.6112 22.6315 18.5853C22.6709 18.5593 22.7029 18.5223 22.7236 18.4781C22.7444 18.434 22.7532 18.3845 22.7491 18.3355C22.7449 18.2863 22.7279 18.2394 22.7 18.2L20.2 14.6587ZM22.5 13.3125C22.6327 13.3125 22.7599 13.2566 22.8536 13.1569C22.9474 13.0573 23.0001 12.9222 23.0001 12.7812C23.0001 12.6404 22.9474 12.5053 22.8536 12.4056C22.7599 12.306 22.6327 12.2501 22.5 12.2501L17.5 12.2501C17.3674 12.2501 17.2402 12.306 17.1465 12.4056C17.0527 12.5053 17 12.6404 17 12.7812C17 12.9222 17.0527 13.0573 17.1465 13.1569C17.2402 13.2565 17.3674 13.3125 17.5 13.3125L22.5 13.3125Z",
    fill: "#C7C7C7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_2488",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_2488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_2488",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.7f6d0647dffa2f4e84d078b34327ced8.svg";
export { ForwardRef as ReactComponent };